import { render } from "./Virtual.vue?vue&type=template&id=be408656"
import script from "./Virtual.vue?vue&type=script&lang=js"
export * from "./Virtual.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__